import { IsNotEmpty, IsNumber, IsOneOfThese, IsValidNumberOrPercentage } from '@core/services/csv/CSVCustomValidator'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { Expose, Transform } from 'class-transformer'

export class IntermediaryCsvModel extends CSVModelInterface {
  static ifamList: Array<{
    oid: string;
    nric: string;
    email: string;
    name: string;
  }> = []

  static nonIfam: Array<{
    oid: string;
    nric: string;
    email: string;
    name: string;
  }> = []

  @Expose()
  @IsNotEmpty()
  private 'Policy Number' = 'Policy 123'

  get policyNumber () {
    return this['Policy Number']
  }

  @Expose()
  @IsNotEmpty()
  private 'NRIC/FIN/Passport/UEN No' = 'S1234567H'

  get nric () {
    return this['NRIC/FIN/Passport/UEN No']
  }

  @Expose()
  @IsOneOfThese(['yes', 'no'])
  private 'Is IFAM User (yes/no)' = 'yes'

  get isIfamUser (): boolean {
    return this['Is IFAM User (yes/no)']?.toLowerCase() === 'yes'
  }

  get userList () {
    return this.isIfamUser ? IntermediaryCsvModel.ifamList : IntermediaryCsvModel.nonIfam
  }

  get userSystemOid () {
    const list = this.isIfamUser ? IntermediaryCsvModel.ifamList : IntermediaryCsvModel.nonIfam
    return list.find(e => e.nric === this.nric)?.oid
  }

  get email () {
    const list = this.isIfamUser ? IntermediaryCsvModel.ifamList : IntermediaryCsvModel.nonIfam
    return list.find(e => e.nric === this.nric)?.email
  }

  get name () {
    const list = this.isIfamUser ? IntermediaryCsvModel.ifamList : IntermediaryCsvModel.nonIfam
    return list.find(e => e.nric === this.nric)?.name
  }
}
